export const LOAD_FAVORITE_FUNDS_REQUEST = 'LOAD_FAVORITE_FUNDS_REQUEST'
export const LOAD_FAVORITE_FUNDS_SUCCESS = 'LOAD_FAVORITE_FUNDS_SUCCESS'
export const LOAD_FAVORITE_FUNDS_FAILURE = 'LOAD_FAVORITE_FUNDS_FAILURE'
